<template>
  <FooterClickLink
    :href="url"
    target="_blank"
    :aria-label="label"
    class="inline-flex items-center justify-center text-white bg-dark-blue border-white hover:bg-white hover:text-dark-blue hover:border-dark-blue border-solid border rounded-full !p-3 mr-3"
  >
    <IconComponent
      :pack="iconPack"
      :icon="icon"
      aria-hidden="true"
      class="w-4 h-4"
    />
  </FooterClickLink>
</template>

<script>
import FooterClickLink from "./FooterClickLink.vue";

export default {
  components: { FooterClickLink },
  props: {
    url: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconPack: {
      type: String,
      default: "fab",
    },
  },
};
</script>
